// DS: I10
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
const Comment = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22 2H5L2 5v13h4v4h2l4-4h7l3-3z"
    })));
};
Comment.displayName = 'Comment';
export default Comment;

//# sourceMappingURL=Comment.js.map